var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 10C20.4375 15.5228 15.9603 20 10.4375 20C4.91465 20 0.4375 15.5228 0.4375 10C0.4375 4.47715 4.91465 0 10.4375 0C15.9603 0 20.4375 4.47715 20.4375 10Z",
    fill: "#0A8F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4375 0C15.9603 0 20.4375 4.47715 20.4375 10C20.4375 15.5228 15.9603 20 10.4375 20C4.91465 20 0.4375 15.5228 0.4375 10C0.4375 4.47715 4.91465 0 10.4375 0ZM16.7803 6.53033C17.0732 6.23743 17.0732 5.76257 16.7803 5.46967C16.4874 5.17677 16.0126 5.17677 15.7197 5.46967L8.75 12.4393L6.28033 9.96967C5.98743 9.67677 5.51257 9.67677 5.21967 9.96967C4.92676 10.2626 4.92676 10.7374 5.21967 11.0303L8.21967 14.0303C8.51257 14.3232 8.98743 14.3232 9.28033 14.0303L16.7803 6.53033Z",
    fill: "#A8E0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreen);
export default __webpack_public_path__ + "static/media/IconGreen.c9e33869b5cce957453011b3918835ba.svg";
export { ForwardRef as ReactComponent };